import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WE_PEDIDOS_LOGO_URL as mozzoIcon } from "../../services/local/institutionalBranding";
import {
  completeWeAuthCallback,
  updateWeCustomerPassword,
} from "../../services/supabase/weCustomerAuthService";
import useWePedidosBranding from "./useWePedidosBranding";
import "../../styles/WePedidos.css";

export default function WeCustomerAuthCallback() {
  useWePedidosBranding("Acceso");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [readyForPassword, setReadyForPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let mounted = true;
    completeWeAuthCallback(window.location.href)
      .then(() => {
        if (!mounted) return;
        const isRecovery =
          new URL(window.location.href).searchParams.get("mode") === "recovery";
        if (isRecovery) {
          setReadyForPassword(true);
        } else {
          navigate("/we-pedidos", { replace: true });
        }
      })
      .catch((requestError) => {
        if (mounted) {
          setError(
            requestError?.message || "No pudimos confirmar tu cuenta de We! pedidos."
          );
        }
      });
    return () => {
      mounted = false;
    };
  }, [navigate]);

  const handlePasswordUpdate = async (event) => {
    event.preventDefault();
    setError("");
    if (password !== confirmation) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    setSaving(true);
    try {
      await updateWeCustomerPassword(password);
      navigate("/we-pedidos", { replace: true });
    } catch (requestError) {
      setError(requestError?.message || "No pudimos actualizar la contraseña.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="we-app-shell">
      <section className="we-loading we-auth-callback">
        <img className="we-logo-image" src={mozzoIcon} alt="" />
        {readyForPassword ? (
          <form className="we-callback-password-form" onSubmit={handlePasswordUpdate}>
            <h1>Elegí una contraseña nueva</h1>
            <label>
              Nueva contraseña
              <input
                type="password"
                minLength={8}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </label>
            <label>
              Repetir contraseña
              <input
                type="password"
                minLength={8}
                value={confirmation}
                onChange={(event) => setConfirmation(event.target.value)}
                required
              />
            </label>
            {error ? <p className="we-inline-error" role="alert">{error}</p> : null}
            <button className="we-primary-button" type="submit" disabled={saving}>
              {saving ? "Guardando..." : "Guardar contraseña"}
            </button>
          </form>
        ) : error ? (
          <>
            <h1>No pudimos confirmar el acceso</h1>
            <p>{error}</p>
            <a className="we-primary-button" href="/we-pedidos">
              Volver a We! pedidos
            </a>
          </>
        ) : (
          <>
            <h1>Confirmando tu cuenta</h1>
            <p>En un momento vas a volver a We! pedidos.</p>
          </>
        )}
      </section>
    </main>
  );
}
